export default __webpack_public_path__ + "static/media/addStaffWrapper.578a778e.svg";